(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Azione', Azione);

    Azione.$inject = ['$resource'];

    function Azione ($resource) {
        var resourceUrl =  'api/aziones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
